interface BoardBuilderProjectionsHeaderProps {
  isDisplayTimeVisible: boolean;
}

export const BoardBuilderProjectionsHeader = ({
  isDisplayTimeVisible
}: BoardBuilderProjectionsHeaderProps) => (
  <thead className="font-heebo text-soClean-180 text-sm font-medium leading-tight tracking-tight">
    <tr>
      <th className="py-3 pl-16 text-left font-normal">Player Profile</th>
      <th className="py-3 font-normal">Projection</th>
      <th className="py-3 font-normal">Board time</th>
      <th className="py-3 font-normal">Start time</th>
      {isDisplayTimeVisible && (
        <th className="py-3 font-normal">Display time</th>
      )}
      <th className="py-3 font-normal">Game Mode</th>
      <th className="py-3 font-normal">Rank</th>
      <th className="py-3 font-normal">Min Prob</th>
      <th className="py-3 font-normal">Target Prob</th>
      <th className="py-3 font-normal">Max Prob</th>
    </tr>
  </thead>
);
